<template>
  <div ref="input" class="app-input app-input-container app-intl-input">
    <input
      type="tel"
      :placeholder="placeholder"
      :value="modelValue"
      @blur="handleBlur"
      @input="handleInput"
    />
  </div>
</template>

<script>
import intlTelInput from 'intl-tel-input'
import * as intlUtils from 'intl-tel-input/build/js/utils'

import 'intl-tel-input/build/css/intlTelInput.css'

export default {
  props: {
    modelValue: {
      type: String,
    },

    placeholder: {
      type: String,
      default: '',
    },
  },

  mounted() {
    this.inputId = this.$refs.input.id

    this.input = document.querySelector(`#${this.inputId} input`)
    this.errorMessage = document.querySelector(
      `#${this.inputId} .error-message`
    )
    this.validMessage = document.querySelector(
      `#${this.inputId} .valid-message`
    )

    this.itl = intlTelInput(this.input, {
      utilsScript: intlUtils,
      separateDialCode: true,
      initialCountry: 'us',
    })
  },
  methods: {
    handleInput(event) {
      this.$emit('update:modelValue', event.target.value)
      if (!this.input.value.trim()) return
    },
  },
}
</script>
